import { getPage } from './getPage';
import { getUser } from './getUser';
import { getProducts } from './get_products';
import { ISurveyAnalyticsParams } from './types';

export function getSurveyAnalyticsParams(params: ISurveyAnalyticsParams) {
  const { category, offer, user, abGroup, agent } = params;
  const products = getProducts({ agent, offer, kpId: null, withOutParent: true });

  return {
    category,
    name: 'oldevent',
    page: getPage(agent, offer),
    products: [
      {
        ...products,
        variant: products.variant ? products.variant.split('/') : [],
      },
    ],
    user: getUser(user, abGroup),
  };
}
